/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./global');
import VueDraggable from 'vuedraggable';
import vSelect from 'vue-select';
import LinkPrevue from 'link-prevue';
import Nl2br from 'vue-nl2br'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css';
import VSwitch from 'v-switch-case'
import * as VueGoogleMaps from 'vue2-google-maps';
import swal from 'sweetalert2';
import vco from 'v-click-outside';

window.Swal = swal;
window.moment = require('moment')
window.moment.locale('ro');

window.Swiper = Swiper

window.Vue = require('vue');
window.Vue.use(VueDraggable);
window.Vue.component('v-select', vSelect);
window.Vue.use(LinkPrevue);

window.EventBus = new Vue();
Number.prototype.format = function(n, x, s, c) {

    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
      num = this.toFixed(Math.max(0, ~~n));
    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));

};

Vue.use(VSwitch)
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBE-jpN0KS7gEma0BEEoONBcb443Cgmr40',
        libraries: 'drawing', // This is required if you use the Autocomplete plugin
        language: 'ro'
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

Vue.use(vco);

window.Vue.mixin({
    data() {
        return {
            MIX_STORAGE_URL: process.env.MIX_STORAGE_URL,
            MIX_APP_URL: process.env.MIX_APP_URL,
            MIX_RECAPTCHA_SITE_KEY: process.env.MIX_RECAPTCHA_SITE_KEY,
            MIX_TINYMCE_API_KEY: process.env.MIX_TINYMCE_API_KEY
        }
    },
    methods: {
        triggerLoader(loaderState) {
            let loader = document.getElementById('loader');
            if(loaderState) {
                loader.style.display = "block";
            } else {
                loader.style.display = "none";
            }
        },
        clientName(client) {
          return client.first_name + ' ' + client.last_name;
        },
        dateHumanize(date) {
            return window.dateHumanize(date);
        },
        formatPrice(price, includeCurrency = true) {
            price = Number(price);
            if(price === null || isNaN(price)) {
                return '';
            }
            let output = price.format(0,3,' ');
            if(includeCurrency) {
                output += ' €';
            }
            return output;
        },
        copyLink(project, type) {
            window.copyLink(project, type);
        },
        copyLinkList(project){
            window.copyLinkList(project);
        },
        getFullModelUrl(model) {
            return window.getFullModelUrl(model);
        },
        openAddFavoriteProjectModal(id) {
            window.openAddFavoriteProjectModal(id);
        },
        openAddFavoriteModelModal(id,projectId) {
            window.openAddFavoriteModelModal(id, projectId);
        },
        getLocalFavorites() {
            window.getLocalFavorites();
        },
        saveLocalFavorites(favorites) {
            window.saveLocalFavorites(favorites);
        },
        openModelDetailModal(projectId, modelId, from='', isAvailabilityTab = false, buildingsFilterFirst = {}) {
            window.openModelDetailModal(projectId, modelId, from, isAvailabilityTab, buildingsFilterFirst)
        },
        getAllUrlParams(url) {
            return window.getAllUrlParams(url);
        },
        getProjectListRelativeUrl(urlParams) {
            return window.getProjectListRelativeUrl(urlParams);
        },
        getProjectNewsfeedRelativeUrl(citySlugs) {
            return window.getProjectNewsfeedRelativeUrl(citySlugs);
        },
        getModelHashTagWithoutType(model) {
            return window.getModelHashTagWithoutType(model);
        },
        getModelHashTagWithType(model) {
            return window.getModelHashTagWithType(model);
        },
        getModelProfileImage(model, imageCategories) {
            return window.getModelProfileImage(model, imageCategories);
        },
        setCookie(cname, cvalue, exdays) {
            window.setCookie(cname, cvalue, exdays);
        },
        getCookie(cname) {
            return window.getCookie(cname);
        },
        deleteCookie(cname) {
            window.deleteCookie(cname);
        },
        openPublicContactModalProject(project, model=null) {
            window.openPublicContactModalProject(project,model);
        },
        openAppointmentModalProject(project, model=null) {
            window.openAppointmentModalProject(project, model);
        },
        openEditBuildingModal(buildingId, type) {
            window.openEditBuildingModal(buildingId, type);
        },
        openAddBuildingModal(projectId) {
            window.openAddBuildingModal(projectId);
        },
        openEditProjectAccess(projectId) {
            window.openEditProjectAccess(projectId);
        },
        transformArrayToQueryParams(params) {
            return window.transformArrayToQueryParams(params);
        },
        openAssignClientModal(item) {
            window.openAssignClientModal(item);
        },
        openItemDetailModal(itemId,canManage=false) {
            window.openItemDetailModal(itemId, canManage);
        },
        openEditModelItemsModal(modelId, itemId) {
            window.openEditModelItemsModal(modelId, itemId);
        },
        openEditHouseItemsModal(modelId, itemId) {
            window.openEditHouseItemsModal(modelId, itemId);
        },
        openEditNotesFavoriteModal(favoriteId) {
            window.openEditNotesFavoriteModal(favoriteId);
        },
        openEditNotesLocalFavoriteModal(favorite) {
            window.openEditNotesLocalFavoriteModal(favorite);
        },
        openEditNewsfeedPostModal(newsfeedPost, newsfeedPostImages) {
            window.openEditNewsfeedPostModal(newsfeedPost, newsfeedPostImages);
        },
        openChooseModelModal(projectId, type) {
            window.openChooseModelModal(projectId, type);
        },
        deleteModel(modelId) {
            window.deleteModel(modelId);
        },
        deleteItem(itemId) {
            window.deleteItem(itemId);
        },
        getBackLink() {
            return window.getBackLink()
        }
    }
})

Vue.prototype.$userId = document.querySelector("meta[name='user-id']").getAttribute('content');
Vue.prototype.$userEmail = document.querySelector("meta[name='user-email']").getAttribute('content');
Vue.prototype.$userPhone = document.querySelector("meta[name='user-phone']").getAttribute('content');
Vue.prototype.$eventBus = window.EventBus; // Global event bus

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
window.Vue.component('nl2br', Nl2br);
window.Vue.component('search-component', require('./components/SearchComponent.vue').default);
window.Vue.component('gm-define-area', require('./components/partials/GMDefineArea.vue').default);
window.Vue.component('add-project-step1', require('./components/developer/AddProjectStep1.vue').default);
window.Vue.component('add-project-step2', require('./components/developer/AddProjectStep2.vue').default);
window.Vue.component('add-project-step3', require('./components/developer/AddProjectStep3.vue').default);
window.Vue.component('add-project-step3-house', require('./components/developer/AddProjectStep3House.vue').default);
window.Vue.component('edit-project', require('./components/developer/EditProject.vue').default);
window.Vue.component('add-block-modal', require('./components/developer/partials/AddBlockModal.vue').default);
// window.Vue.component('editor', require('./components/partials/Editor.vue').default);
// window.Vue.component('icon', require('./components/partials/Editor.vue').default);
window.Vue.component('edit-model', require('./components/developer/EditModel.vue').default);
window.Vue.component('assign-client', require('./components/developer/project/partials/AssignClient.vue').default);
window.Vue.component('developer-item-details-modal', require('./components/developer/project/partials/DeveloperItemDetailsModal.vue').default);
window.Vue.component('developer-list-apartment-models', require('./components/developer/project/partials/DeveloperListApartmentModels.vue').default);
window.Vue.component('developer-list-commercial-models', require('./components/developer/project/partials/DeveloperListCommercialModels.vue').default);
window.Vue.component('developer-list-apartment-buildings', require('./components/developer/project/partials/DeveloperListApartmentBuildings.vue').default);
window.Vue.component('developer-list-commercial-buildings', require('./components/developer/project/partials/DeveloperListCommercialBuildings.vue').default);
window.Vue.component('developer-list-apartment-commercial-models', require('./components/developer/project/partials/DeveloperListApartmentCommercialModels.vue').default);
window.Vue.component('developer-list-apartment-commercial-buildings', require('./components/developer/project/partials/DeveloperListApartmentCommercialBuildings.vue').default);
window.Vue.component('developer-list-houses', require('./components/developer/project/partials/DeveloperListHouses.vue').default);
window.Vue.component('developer-edit-model-items', require('./components/developer/project/partials/DeveloperEditModelItems.vue').default);
window.Vue.component('developer-edit-house-items', require('./components/developer/project/partials/DeveloperEditHouseItems.vue').default);
window.Vue.component('developer-model-details', require('./components/developer/project/DeveloperModelDetails.vue').default);
window.Vue.component('developer-edit-building', require('./components/developer/project/partials/DeveloperEditBuilding.vue').default);
window.Vue.component('developer-edit-project-access', require('./components/developer/project/partials/DeveloperEditProjectAccess.vue').default);
window.Vue.component('developer-choose-model-modal', require('./components/developer/project/partials/DeveloperChooseModelModal').default);
window.Vue.component('public-project-apartment-models', require('./components/public/partials/PublicProjectApartmentModels.vue').default);
window.Vue.component('public-project-apartment-buildings', require('./components/public/partials/PublicProjectApartmentBuildings.vue').default);
window.Vue.component('public-project-houses', require('./components/public/partials/PublicProjectHouses.vue').default);
window.Vue.component('public-project-commercial-buildings', require('./components/public/partials/PublicProjectCommercialBuildings.vue').default);
window.Vue.component('public-project-commercial-models', require('./components/public/partials/PublicProjectCommercialModels.vue').default);
window.Vue.component('public-project-model-details', require('./components/public/partials/PublicProjectModelDetails.vue').default);
window.Vue.component('public-project-contact', require('./components/public/partials/PublicContactProject.vue').default);
window.Vue.component('public-projects-list', require('./components/public/PublicProjectsList.vue').default);
window.Vue.component('public-developer-news-list', require('./components/public/PublicDeveloperNewsList.vue').default);
window.Vue.component('messages', require('./components/messages/Messages.vue').default);
window.Vue.component('message-modal', require('./components/messages/partials/MessageModal.vue').default);
window.Vue.component('list-projects-map', require('./components/public/partials/ListProjectsMap.vue').default);
window.Vue.component('favourite-item-modal', require('./components/public/partials/FavouriteItemModal.vue').default);
window.Vue.component('edit-notes-favorite-modal', require('./components/public/partials/EditNotesFavoriteModal.vue').default);
window.Vue.component('public-contact-modal-project', require('./components/public/partials/PublicContactModalProject.vue').default);
window.Vue.component('public-appointment-modal-project', require('./components/public/partials/PublicProjectAppointmentModal.vue').default);
window.Vue.component('public-project-favorite-models', require('./components/public/partials/PublicProjectFavoriteModels').default);
window.Vue.component('public-project-buildings', require('./components/public/partials/PublicProjectBuildings').default);
window.Vue.component('add-newsfeed-post', require('./components/developer/AddNewsfeedPost.vue').default);
window.Vue.component('newsfeed-post', require('./components/developer/NewsfeedPost.vue').default);
window.Vue.component('guest-favorites-list', require('./components/public/GuestFavoritesList.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

new window.Vue({
    el: '#app',
});
